import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from 'react-router-dom';
import { isAuthenticated, isShop } from './lib/pocketbase';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import CategoriesPage from './pages/CategoriesPage';
import ProductsPage from './pages/ProductsPage';
import AdminsPage from './pages/AdminsPage';
import ShopsPage from './pages/ShopsPage';
import OrdersPage from './pages/OrdersPage';
import UsersPage from './pages/UsersPage';
import ChatPage from './pages/ChatPage';
import CommentsPage from './pages/CommentsPage';

const SHOP_ALLOWED_PATHS = ['/', '/chat'];

// Protected Route Component
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
};

const ProtectedLayoutRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const location = useLocation();
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  if (isShop() && !SHOP_ALLOWED_PATHS.includes(location.pathname)) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
};

const App: React.FC = () => {
  return (
    <Router>
      <div className="font-persian">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <ProtectedLayoutRoute>
                <Layout>
                  <DashboardPage />
                </Layout>
              </ProtectedLayoutRoute>
            }
          />
          <Route
            path="/categories"
            element={
              <ProtectedLayoutRoute>
                <Layout>
                  <CategoriesPage />
                </Layout>
              </ProtectedLayoutRoute>
            }
          />
          <Route
            path="/products"
            element={
              <ProtectedLayoutRoute>
                <Layout>
                  <ProductsPage />
                </Layout>
              </ProtectedLayoutRoute>
            }
          />
          <Route
            path="/admins"
            element={
              <ProtectedLayoutRoute>
                <Layout>
                  <AdminsPage />
                </Layout>
              </ProtectedLayoutRoute>
            }
          />
          <Route
            path="/shops"
            element={
              <ProtectedLayoutRoute>
                <Layout>
                  <ShopsPage />
                </Layout>
              </ProtectedLayoutRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <ProtectedLayoutRoute>
                <Layout>
                  <OrdersPage />
                </Layout>
              </ProtectedLayoutRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedLayoutRoute>
                <Layout>
                  <UsersPage />
                </Layout>
              </ProtectedLayoutRoute>
            }
          />
          <Route
            path="/chat"
            element={
              <ProtectedRoute>
                <ChatPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/comments"
            element={
              <ProtectedLayoutRoute>
                <Layout>
                  <CommentsPage />
                </Layout>
              </ProtectedLayoutRoute>
            }
          />
        </Routes>
      </div>
    </Router>
  );
};

export default App; 